
import { useState } from 'react';
import { Link } from 'react-router-dom';

interface Collection {
  id: number;
  link: string;
  image: string;
}

const collections: Collection[] = [
  {
    id: 1,
    link: "/proyectos",
    image: "images/proyectos/p01.jpg",
  },
  {
    id: 2,
    link: "/proyectos",
    image: "images/proyectos/p04.jpg",
  },
  {
    id: 3,
    link: "/proyectos",
    image: "images/proyectos/p14.jpeg",
  },
  {
    id: 4,
    link: "/proyectos",
    image: "images/proyectos/p03.jpg",
  },
  {
    id: 5,
    link: "/proyectos",
    image: "images/proyectos/p31.jpeg",
  },
  {
    id: 6,
    link: "/proyectos",
    image: "images/proyectos/p41.jpeg",
  }
];

export default function CollectionsGrid() {
  const [hoveredCollection, setHoveredCollection] = useState<number | null>(null);

  return (
    <section className="collections-grid py-20 bg-white">
      <div className="container mx-auto px-4">
        <h2 className="text-center text-4xl md:text-5xl font-light mb-16">Nuestros proyectos</h2>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {collections.map((collection) => (
            <a
              key={collection.id}
              href={collection.link}
              className="collection-link relative h-96 overflow-hidden group cursor-pointer"
              onMouseEnter={() => setHoveredCollection(collection.id)}
              onMouseLeave={() => setHoveredCollection(null)}
            >
              <picture className="collection-background absolute inset-0">
                <source srcSet={collection.image} />
                {/* img fallback so the picture displays in all browsers */}
                <img src={collection.image} className="w-full h-full object-cover" />
              </picture>
              
              <div className={`collection-overlay absolute inset-0 bg-[#191a19]/30 transition-opacity duration-300 ${hoveredCollection === collection.id ? 'bg-[#191a19]/40' : ''}`}></div>
            </a>
          ))}
        </div>

        <div className="text-center mt-16">
          <Link to="/proyectos" 
            className="inline-block bg-[#191a19] text-white px-8 py-4 hover:bg-gray-800 transition-colors cursor-pointer whitespace-nowrap"
          >
            Proyectos
          </Link>
        </div>
      </div>
    </section>
  );
}
